module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.54f612f4.ttf";